export const ADDRESS_LEVEL_NAMES = {
  1: 'region',
  2: 'locality',
  3: 'neighbourhood'
} as const
